import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import InvoicePreview from './InvoicePreview';
import { downloadInvoicePdf, fetchInvoice } from '../utils/billing';

function InvoiceView() {
  const { id } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [error, setError] = useState('');
  const previewRef = useRef(null);

  useEffect(() => { fetchInvoice(id).then(setInvoice).catch((requestError) => setError(requestError.message || 'Unable to load invoice.')); }, [id]);

  if (error) return <div className="billing-page"><div className="billing-error">{error}</div><Link className="btn-secondary" to="/billing">Back to Billing</Link></div>;
  if (!invoice) return <div className="billing-page"><p className="muted">Loading invoice...</p></div>;
  const downloadPreviewPdf = async () => {
    try { await downloadInvoicePdf(invoice, previewRef.current); } catch (requestError) { setError(requestError.message || 'Unable to generate PDF.'); }
  };
  return <div className="billing-page"><div className="billing-page-header"><div><p className="eyebrow">Billing / Invoice</p><h1>{invoice.invoiceNumber}</h1></div><div className="billing-actions"><Link className="btn-secondary" to="/billing">Back</Link><Link className="btn-secondary" to={`/billing/create?edit=${invoice._id}`}>Edit</Link><button type="button" className="btn-primary" onClick={downloadPreviewPdf}>Download PDF</button></div></div>{error ? <div className="billing-error">{error}</div> : null}<InvoicePreview ref={previewRef} invoice={invoice} /></div>;
}

export default InvoiceView;